import * as React from 'react'
import { GridEventListener } from '../../../models'
import { GridPrivateApiCommunity } from '../../../models/api/gridApiCommunity'
import { useGridApiEventHandler } from '../../utils/useGridApiEventHandler'
import { isEnterKey } from '../../../utils/keyboardUtils'

export const useGridSorting = (
  apiRef: React.MutableRefObject<GridPrivateApiCommunity>
) => {
  const handleColumnHeaderClick = React.useCallback<
    GridEventListener<'columnHeaderClick'>
  >(
    ({ field }, event) => {
      const currentColumn = apiRef.current.tableInstance.getColumn(field)
      if (!currentColumn) {
        return
      }
      const canSort = currentColumn.getCanSort()
      if (canSort) {
        currentColumn.getToggleSortingHandler()!(event)
      }
    },
    [apiRef]
  )

  const handleColumnHeaderKeyDown = React.useCallback<
    GridEventListener<'columnHeaderKeyDown'>
  >(
    ({ field }, event) => {
      if (isEnterKey(event.key) && !event.ctrlKey && !event.metaKey) {
        const currentColumn = apiRef.current.tableInstance.getColumn(field)
        if (!currentColumn) {
          return
        }
        const canSort = currentColumn.getCanSort()
        if (canSort) {
          currentColumn.getToggleSortingHandler()!(event)
        }
      }
    },
    [apiRef]
  )

  useGridApiEventHandler(apiRef, 'columnHeaderClick', handleColumnHeaderClick)
  useGridApiEventHandler(
    apiRef,
    'columnHeaderKeyDown',
    handleColumnHeaderKeyDown
  )
}
